/** Join feedback sentences without introducing another punctuation separator. */
export function formatCheckFeedback(feedback: readonly string[]): string {
  return feedback
    .map((point) => point.trim())
    .filter((point) => point.length > 0)
    .map((point) => (/[.!?…]["'”’)\]}]*$/.test(point) ? point : `${point}.`))
    .join(' ');
}

/**
 * Display older feedback that was joined with ". " after an existing period.
 * Only exact double periods at a sentence boundary are repaired. Keep URL
 * tokens and longer ellipses intact because their punctuation is meaningful.
 * Stored feedback remains unchanged.
 */
export function normalizeHistoricalCheckFeedback(feedback: string | null | undefined): string {
  return (feedback ?? '')
    .trim()
    .replace(/(?<!\.)\.\.(?!\.)(?=\s|$)/g, (_match: string, offset: number, text: string) => {
      const precedingToken = text.slice(0, offset).match(/\S+$/)?.[0] ?? '';
      return /(?:[a-z][a-z\d+.-]*:\/\/|www\.)/i.test(precedingToken) ? '..' : '.';
    });
}
